import React from 'react'
import Doctor from './Doctor'
import {Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top"
import Navbar from '../inc/Navbar';
function Doctorpage() {
  return (
    <div>
           <Navbar/>
        <br/>
        <br/>
        <br />
     
         <ScrollToTop smooth top="100" color="Darkblue"/>
         <div className='bestorthopedicskatwa'>
                <br />
                <div className="album py-1">

                    <div className="container">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"> Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Doctor</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <br/>
        
        <Doctor/>
        <br/>
    </div>
  )
}

export default Doctorpage